<!-- src/layouts/PublicShell.vue -->
<script setup>
</script>

<template>
  <div class="public-shell">
    <router-view />
  </div>
</template>
